import { AvvirEvent } from "type_aliases";

export type PointCloudPointSizeChangedEvent = AvvirEvent<typeof POINT_CLOUD_POINT_SIZE_CHANGED, number>

const pointCloudPointSizeChanged = (pointSize: number): PointCloudPointSizeChangedEvent => ({
  type: POINT_CLOUD_POINT_SIZE_CHANGED,
  payload: pointSize
});

export const POINT_CLOUD_POINT_SIZE_CHANGED = "point_cloud_point_size_changed";

export default pointCloudPointSizeChanged;
